import { Injectable, inject } from '@angular/core';
import { mutationOptions } from '@tanstack/angular-query-experimental';
import { firstValueFrom } from 'rxjs';

import { EVENT_SUPPORT_REQUEST_SUBMITTED } from '../analytics/events';
import { SendSupportRequest, SendSupportRequestResponse } from '../generated-api/models';
import { AnalyticsService } from './analytics.service';
import { BackendService } from './backend.service';

@Injectable({ providedIn: 'root' })
export class SupportService {
  private analytics = inject(AnalyticsService);
  private backend = inject(BackendService);

  sendSupportRequestMutationOptions() {
    return mutationOptions({
      mutationKey: ['support', 'send'],
      mutationFn: (data: SendSupportRequest) => this.sendSupportRequest(data),
      // The conversation id on the PostHog event is the reverse link: the
      // ChatWoot side carries the session replay URL, this side carries the
      // conversation, so either tool can jump to the other. Guarded so an
      // analytics hiccup can't turn an already-filed request into an error.
      onSuccess: response => {
        try {
          this.analytics.sendEvent(EVENT_SUPPORT_REQUEST_SUBMITTED, {
            conversation_id: response.conversationId,
          });
        } catch {
          // intentionally swallowed
        }
      },
    });
  }

  private sendSupportRequest(data: SendSupportRequest): Promise<SendSupportRequestResponse> {
    return firstValueFrom(
      this.backend.request<SendSupportRequestResponse, SendSupportRequest>({
        type: 'post',
        apiRoute: 'support',
        timeoutMillis: 15000,
        data,
      }),
    );
  }
}
